(function() {
  "use strict"
  
  angular.module("ATMGApi")
  /**
  *
  *  Shipping Handling
  *
  *  it's better to keep shipping hanlding logic out of the cart
  */
  
  .factory("Api.Shipping", [
    "ApiQuery",
    "$q",
    "$rootScope",
    "ErrorService",
    function( ApiQuery, $q, $rootScope, Errors ) {
      
      return  {
        
        freightOptions: undefined,
        shippingOptions: undefined,
        
        moduleName: "shipping",         //  errors module name
        
        loading: false,
        startLoading: function() {
          this.clearErrors();
          this.loading = true;
        },
        doneLoading: function() {
          this.loading = false;
        },
        
        // Errors handling
        error: function( msg ) {
          Errors.set( msg, this.moduleName )
        },
        clearErrors: function() {
          Errors.reset( this.moduleName )
        },
        
        cleanup: function() {
          this.freightOptions = undefined;
          this.shippingOptions = undefined;
        },
        
        /**
        *
        *  getFreightOptions
        *
        */
        getFreightOptions: function(payload, cart_id) {
          
          cart_id = cart_id || '';
          
          this.freightOptions = undefined;
          this.shippingOptions = undefined;
          
          this.startLoading();

          return new Promise((resolve, reject) => {
            ApiQuery("shipping/freight/" + cart_id, payload, "GET" )
            .then(response => {
              this.doneLoading();
              this.freightOptions = response.data.data;
              return resolve( true )
            })
            .catch(reason => {
              this.doneLoading();
              reject(reason )
              this.error(reason.data.message)
            })
          })
        },
        
        /**
        *
        *   getShippingOptions
        *
        *
        */
        getShippingOptions: function(payload, cart_id) {
          cart_id = cart_id || ''
          this.shippingOptions = undefined;
            this.startLoading();
            return new Promise((resolve, reject) => 
              ApiQuery('shipping/options/' + cart_id, payload, 'POST') 
                .then(response => {
                  this.doneLoading();
                  this.shippingOptions = response.data.data
                  return resolve(true)
                })
                .catch(reason => {
                  this.doneLoading();
                  return reject(false)
                  this.error(reason.message)
                })
            )
          },
          
          /**
          *
          *  updateShipping
          *
          */
          updateShipping: function(params, cart_id) {
            cart_id = cart_id || ''
            this.startLoading();
            return new Promise((resolve, reject) => {
              return ApiQuery('shipping/' + cart_id, params , 'POST')
                .then(response => {
                  this.doneLoading();
                  return resolve(true)
                })
                .catch(reason => {
                  this.doneLoading();
                  this.error( reason.message )
                  return reject(false)
                })
            })
          },
          
          /**
          *
          *   Send Request Freight Quote
          *
          *
          */
          requestFreightQuote: function( ) {
            return ApiQuery( "shipping/quote", "", "GET" )
          }
        }
      }
    ])
  })()


// WEBPACK FOOTER //
// ./src/app/modules/ATMGApi/factories/Shipping.js